import { render, staticRenderFns } from "./TabGraficoMargemBrutaOperacional.vue?vue&type=template&id=1fa14993&scoped=true&"
import script from "./TabGraficoMargemBrutaOperacional.vue?vue&type=script&lang=js&"
export * from "./TabGraficoMargemBrutaOperacional.vue?vue&type=script&lang=js&"
import style0 from "./TabGraficoMargemBrutaOperacional.vue?vue&type=style&index=0&id=1fa14993&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa14993",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VCard,VFlex,VTabItem,VTabs})
